<template>
    <b-modal
        v-model="modalShow"
        :title="$t('assignment.review')"
        :ok-disabled="disabled"
        ok-title="Nakijken"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk()"
        modal-class="apprentice-default-modal">
        <div
            class="assignments-evaluate-complete"
            v-if="!hide_choice">
            <div class="description">
                {{ labelText }}
            </div>
            <b-form-group
                class="assignments-evaluate-users-option apprentice-radiobutton"
                :label="$t('assignment.choose')">
                <b-form-radio
                    v-model="type"
                    name="some-radios"
                    value="1"
                    >{{$t('assignment.next')}}</b-form-radio
                >
                <b-form-radio
                    v-model="type"
                    name="some-radios"
                    value="2"
                    >{{$t('assignment.select')}}</b-form-radio
                >
            </b-form-group>
        </div>

        <div
            class="choose-student"
            v-if="type === '2'">
            <div class="description">
                {{$t('assignment.choose_review')}}
            </div>
            <b-form-group
                :label="$t('assignment.choose')"
                label-for="choose-student-select">
                <b-form-select
                    class="apprentice-primary-select"
                    id="choose-student-select"
                    v-model="selected"
                    :options="assignments"
                    value-field="id"
                    text-field="name">
                </b-form-select>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-assignment-edit-evaluate-next-assignment-modal-component',
    props: ['evaluateIn', 'assignmentId'],
    data() {
        return {
            type: '1',
            start_type: 1,
            selected: null,
            modalShow: false,
            hide_choice: false,
            evaluate: this.evaluateIn,
        };
    },
    computed: {
        assignments() {
            const assignments = this.evaluateIn.lists.assignments.filter(
                (assignment) => assignment.id !== this.assignmentId,
            );
            assignments.unshift({ id: null, name: this.$t('assignment.choose') });
            return assignments;
        },
        disabled() {
            return this.type === '2' && !this.selected;
        },
        labelText() {
            return this.start_type === 1
                ? this.$t('assignment.review_next_assignment')
                : this.$t('assignment.review_option');
        },
    },
    methods: {
        show(select_assignment, hide_choice) {
            if (hide_choice) {
                this.hide_choice = true;
            } else {
                this.hide_choice = false;
            }
            if (select_assignment) {
                this.type = '2';
                this.start_type = 2;
            } else {
                this.type = '1';
                this.start_type = 1;
            }

            this.evaluate = this.evaluateIn;
            this.modalShow = true;
        },
        onOk() {
            if (this.type === '1') {
                window.location.href =
                    this.routes.assignmentShow(this.evaluate.next_assignment_id, this.evaluate.next_project_id) +
                    '?evaluate=1&evaluate_type=2';
            } else if (this.type === '2') {
                if (!this.selected) {
                    return;
                }

                for (const assignment of this.evaluate.lists.assignments) {
                    if (assignment.id !== this.selected) {
                        continue;
                    }
                    const project_id = assignment.projects[0].id;
                    window.location.href =
                        this.routes.assignmentShow(assignment.id, project_id) + '?evaluate=1&evaluate_type=2';
                }
            }
        },
    },
};
</script>

<style scoped lang="scss">
.description {
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.assignments-evaluate-users-option ::v-deep {
    label {
        font-weight: $font-weight-normal;
    }

    .custom-control {
        input[type='radio'] {
            &:checked ~ .custom-control-label {
                font-weight: $font-weight-bold;
            }
        }
    }
}

.assignments-evaluate-users-option:hover ::v-deep {
    .custom-control-label {
        font-weight: $font-weight-normal;
    }

    .custom-control {
        &:hover {
            .custom-control-label {
                font-weight: $font-weight-bold;
            }
        }
    }
}
</style>
